export default __webpack_public_path__ + "static/grzegorczyk-4ce891647993bb74036703d78d1268be.jpg";